import { _ as __rest, a as __assign } from './tslib.es6-01f7d394.js';
import * as React from 'react';

function ArrowDownIcon(_a) {
    var _b = _a.fillColor, fillColor = _b === void 0 ? "currentColor" : _b, props = __rest(_a, ["fillColor"]);
    return (React.createElement("svg", __assign({ width: 8, height: 8, viewBox: "0 0 8 5" }, props),
        React.createElement("path", { fill: fillColor, d: "M7.911.59L4.356 4.43c-.178.185-.534.185-.711 0L.089.59C-.133.333.089 0 .445 0h7.11c.356 0 .578.37.356.59z" })));
}

export { ArrowDownIcon as A };
